var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.autofill-modal")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            _vm._l(_vm.keys, function (key) {
              return _c(
                "w-col",
                { key: key, attrs: { xs: "12", md: "6" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm
                        .$t("models.friendlyNames.contactAutoFill." + key)
                        .toString(),
                      value: _vm.selectedFields[key],
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onValue(key, $event)
                      },
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.getAutofillData(key)) + " "),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }